
const CustomMenuItem = () => (
  <div>
    <p style={{ textAlign: 'center' }}>Custom Menu Item :)</p>
  </div>
);

export default {
  target: 'CustomMenuComponent',
  mode: 'add',
  name: 'CustomMenuItem',
  component: CustomMenuItem,
};